import { styled } from '@mui/system';

export const ControlsRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-evenly',
  flexGrow: 2,
  alignItems: 'center',
  [theme.breakpoints.up('FWXGA')]: {
    flexGrow: 0
  },
  '& button': {
    color: '#00000091',
    borderColor: '#00000038',
    padding: '15px 10px',
    minWidth: 'auto',
    marginLeft: theme.spacing(),
    [theme.breakpoints.down('md')]: {
      padding: '15px 5px',
      minWidth: 'auto'
    }
  }
}));
